const Config = {
  Production: true
}
export default Config;
